// CUSTOM_BLOGBOT_BY_CLAUDE — mobile collection-banner glass card H1: shrink-to-fit so a long
// brand+category title (e.g. "Spirit Fitness Steppers & Stair Climbers") caps at 2 lines instead of
// wrapping to a 3rd, which unnecessarily grows the glass card's height and eats into the banner's
// product-image floor space. Pure CSS can't count wrapped lines and react to it — this measures the
// rendered height against the computed line-height and steps the font-size down until it fits (or
// hits a safety floor, in which case a genuinely long title still wraps to 3 lines rather than
// shrinking to illegibility).
//
// The CRITICAL first fit (the one that reveals the CSS-default-hidden h1 — bb-glass.css hides it
// until it carries .bb-h1-fit-ready) is NOT here — it's duplicated inline in image-banner.liquid,
// on purpose. A deferred external script like this one competes with every other deferred <script>
// on the page for main-thread execution order (100+ on a real collection page), so under real
// network/CPU conditions its document.fonts.ready handler can end up registered several seconds
// late — verified via throttled headless Chrome, where relying on this file alone let a safety-
// timeout fire and reveal the un-shrunk 3-line text before this script had even run. This file only
// handles RE-fitting after the initial critical-path reveal: resize/orientation-change and the
// Shopify theme editor's section-reload event — none of which are flash-sensitive, since the h1 is
// already visible and correctly sized by the time any of these fire.
(function () {
  // Scoped to the h1 tag specifically — the card can also contain an h2 subheading sharing the same
  // .text-overlay__heading class (hidden via display:none on this card variant). Both elements share
  // one ancestor .text-overlay, so if the bare class selector matched both, processing the always-
  // unshrunk (zero-height, hidden) h2 second would toggle the shrunk-marker class back OFF right after
  // the h1's pass turned it on. Restricting to h1 avoids the h2 entirely.
  var SELECTOR = '.cc-image-banner .text-overlay.bb-glass--short:not(.bb-glass--tl) h1.text-overlay__heading';
  var SHRUNK_CLASS = 'bb-h1-fit-shrunk';
  var READY_CLASS = 'bb-h1-fit-ready';
  var MAX_LINES = 2;
  var MIN_FONT_PX = 18;
  var STEP = 0.94;
  var MAX_ITERATIONS = 20;

  function fitOne(el) {
    if (!el) return;
    el.style.fontSize = ''; // reset to the CSS-defined natural size before measuring
    void el.offsetHeight; // force reflow so scrollHeight reflects the reset size
    var cs = getComputedStyle(el);
    var lineHeight = parseFloat(cs.lineHeight);
    var fontSize = parseFloat(cs.fontSize);
    if (!lineHeight || isNaN(lineHeight) || !fontSize || isNaN(fontSize)) { el.classList.add(READY_CLASS); return; }
    var maxHeight = lineHeight * MAX_LINES + 1; // +1px tolerance for subpixel rounding
    var shrunk = false;
    var guard = 0;
    while (el.scrollHeight > maxHeight && fontSize > MIN_FONT_PX && guard < MAX_ITERATIONS) {
      shrunk = true;
      fontSize = Math.max(MIN_FONT_PX, fontSize * STEP);
      // bb-glass.css's font-size rule carries !important (needed elsewhere to beat other cascading
      // rules), which otherwise beats a plain inline style regardless of specificity — an author
      // !important always outranks a normal inline declaration. setProperty(..., 'important') is the
      // only way for an inline override to actually win against that (inline !important is the one
      // thing that outranks author !important in the cascade).
      el.style.setProperty('font-size', fontSize + 'px', 'important');
      // line-height:1.12 (unitless, in bb-glass.css) recomputes against the new font-size
      // automatically — re-read it each pass so maxHeight tracks the shrinking text.
      cs = getComputedStyle(el);
      lineHeight = parseFloat(cs.lineHeight);
      maxHeight = lineHeight * MAX_LINES + 1;
      guard++;
    }
    // Marker class on the ancestor card lightens the H1 + review-line shadows to match the smaller
    // glyphs (bb-glass.css .bb-h1-fit-shrunk rules) — only when a shrink actually happened, so an
    // already-2-line title keeps its normal, heavier shadow.
    var card = el.closest('.text-overlay');
    if (card) card.classList.toggle(SHRUNK_CLASS, shrunk);
    el.classList.add(READY_CLASS);
  }

  function fitAll() {
    if (!window.matchMedia('(max-width:767px)').matches) return;
    document.querySelectorAll(SELECTOR).forEach(fitOne);
  }

  function resetAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.style.fontSize = '';
      var card = el.closest('.text-overlay');
      if (card) card.classList.remove(SHRUNK_CLASS);
    });
  }

  var raf;
  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(fitAll);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (!window.matchMedia('(max-width:767px)').matches) { resetAll(); return; }
      schedule();
    }, 150);
  });

  document.addEventListener('shopify:section:load', schedule);
})();
